import ProductApi from '../interfaces/api';
import appRequest from '../../utils/request';
import { getBase64 } from 'utils/getBase64';
import { UPLOAD_TIMEOUT } from '../../utils/upload-constants';
import { config } from 'config';

/**
 * Product API definitions for production use.
 *
 * These definitions can only be covered by end-to-end (e2e) tests.
 */
const productApiProd: ProductApi = {
  fetchProducts: async () => {
    const { data } = await appRequest(`/product/list/?tenantId=${config.tenantId}`);
    return Array.isArray(data) ? data.filter((product: { active: boolean }) => product.active) : [];
  },
  fetchProductById: async (_id) => {
    const { data } = await appRequest(`product/by-id/${_id}`);
    return data?.data ?? data;
  },
  uploadImageWithAws: async (file: File) => {
    const base64File = await getBase64(file);

    const { data } = await appRequest(`/order/upload-image`,{
      method: 'POST',
      data: JSON.stringify({
        file: base64File,
        filename: file.name,
        filetype: file.type,
      }),
      headers: { 'Content-Type': 'application/json' },
    });

    return data?.data ?? data;
  },
  deleteImageFromAws: async (urls: string[]) => {
    try {
      const { data } = await appRequest(`/order/delete-image`, {
        method: 'POST',
        data: JSON.stringify({ urls }),
        headers: { 'Content-Type': 'application/json' },
      });

      return data?.data ?? data;
    } catch (error) {
      console.error('Error deleting images:', error);
      throw error;
    }
  },

  startUpload: async (filename: string, filetype: string) => {
    const { data } = await appRequest(`order/upload/start`, {
      method: "POST",
      data: JSON.stringify({ filename, filetype }),
      headers: { "Content-Type": "application/json" },
    }, UPLOAD_TIMEOUT);

    return data; // { uploadId, key }
  },

  /**Upload Chunk */
  uploadChunk: async (uploadId: string, partNumber: number, key: string, fileChunk: Blob) => {
    const formData = new FormData();
    formData.append("uploadId", uploadId);
    formData.append("partNumber", partNumber.toString());
    formData.append("key", key);
    formData.append("file", fileChunk);

    const { data } = await appRequest(`order/upload/chunk`, {
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }, UPLOAD_TIMEOUT);

    return data; // { ETag, partNumber }
  },

  /**Complete Upload */
  completeUpload: async (uploadId: string) => {
    const { data } = await appRequest(`order/upload/complete`, {
      method: "POST",
      data: JSON.stringify({ uploadId }),
      headers: { "Content-Type": "application/json" },
    }, UPLOAD_TIMEOUT);

    return data; // { message, url }
  },
};

export default productApiProd;
